import {Component, Input} from '@angular/core';
import {PROFILE_PROVIDERS_NAMES} from '../../../../../../common/constants';

@Component({
    selector: 'tfl-bo-profile-provider-badge',
    template: `
        <span [ngClass]="providerBadgeClass">
            {{ providerBadgeTitle | translate }}
        </span>
    `
})
export class ProfileProviderBadgeComponent {

    providerBadgeClass: any = {};
    providerBadgeTitle: string = '';

    @Input('provider')
    set _state(state: string) {
        this.providerBadgeClass = this.getProviderBadgeClass(state);
        this.providerBadgeTitle = this.getProviderBadgeTitle(state);
    }

    private getProviderBadgeClass(state: string): any {
        return {
            'label        ': true,
            'label-success': state === PROFILE_PROVIDERS_NAMES.MODULR,
            'label-warning': state === PROFILE_PROVIDERS_NAMES.AGENT,
            'label-default': state === PROFILE_PROVIDERS_NAMES.MOORWAND,
            'label-info   ': state === PROFILE_PROVIDERS_NAMES.EMONEY
        };
    }

    private getProviderBadgeTitle(state: string): string {
        switch (state) {
            case PROFILE_PROVIDERS_NAMES.MODULR:
                return 'CUSTOMER.PROVIDER.MODULR';
            case PROFILE_PROVIDERS_NAMES.AGENT:
                return 'CUSTOMER.PROVIDER.AGENT';
            case PROFILE_PROVIDERS_NAMES.MOORWAND:
                return 'CUSTOMER.PROVIDER.MOORWAND';
            case PROFILE_PROVIDERS_NAMES.EMONEY:
                return 'CUSTOMER.PROVIDER.EMONEY';
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-provider-badge.component.ts